import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { WidgetType } from '@enums/WidgetType'
import styles from './modal.module.scss'
import VehicleBanner from './vehicleBanner'
import { CLOSE_BTN_ALT, CLOSE_BTN_ICON } from './commonConstants'

const WidgetModal = ({ setRegNo, setWidgetModal, vehicleData, regNo, children, setVehicleData, widgetType = '' }) => {
  const handleCloseBtnClick = () => {
    setWidgetModal(false)
    setRegNo('')
    setVehicleData({})
  }
  return (
    <div className={styles.widgetModal}>
      <div className={styles.widgetModalWrapper}>
        <div className={styles.closeBtn}>
          <span onClick={handleCloseBtnClick}>
            <Image src={`${assetLoader()}${CLOSE_BTN_ICON}`} alt={CLOSE_BTN_ALT} width={20} height={20} />
          </span>
        </div>
        <PropertyControlledComponent fallback={null} controllerProperty={widgetType !== WidgetType.CHALLAN_WIDGET}>
          <VehicleBanner autoData={vehicleData} regNo={regNo} />
        </PropertyControlledComponent>
        {children}
      </div>
    </div>
  )
}

export default WidgetModal
